enum MileageTrackingVisibility {
  ALL = "ALL", // all users
  TEAM = "TEAM", // owners+managers
  OWNER = "OWNER",
  NONE = "NONE",
}

export default MileageTrackingVisibility;
